import { useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { useToast } from "../components/ui/toast/ToastProvider";

export function useTrialExpiration() {
  const { user } = useAuth();
  const { showToast } = useToast();

  useEffect(() => {
    if (!user) return;

    const checkAndHandleExpiration = async () => {
      try {
        const userDocRef = doc(db, 'users', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (!userDoc.exists()) return;

        const userData = userDoc.data();
        const subscription = userData.subscription;

        // Verificar si el trial ha expirado
        if (subscription?.status === 'trial' && subscription?.trialEnd) {
          const trialEndDate = subscription.trialEnd.toDate();
          const now = new Date();

          if (now > trialEndDate) {

            // 1. Actualizar suscripción a free
            await updateDoc(userDocRef, {
              'subscription.status': 'free',
              'subscription.plan': 'free',
              'subscription.downgradedAt': new Date().toISOString(),
            });

            // 2. Si no es el owner de la familia, downgrade a member
            if (userData.familyId) {
              const familyRef = doc(db, 'families', userData.familyId);
              const familyDoc = await getDoc(familyRef);

              if (familyDoc.exists()) {
                const familyData = familyDoc.data();

                // Si no es el owner, convertir a member
                if (familyData.ownerId !== user.uid) {
                  await updateDoc(userDocRef, {
                    role: 'member',
                  });

                  // Remover de admins de la familia
                  const currentAdmins = familyData.admins || [];
                  const newAdmins = currentAdmins.filter((id: string) => id !== user.uid);
                  await updateDoc(familyRef, { admins: newAdmins });

                }
              }
            }

            // 3. Mostrar notificación
            showToast?.({
              type: 'warning',
              message: 'Tu período de prueba ha expirado. Actualiza tu plan para continuar con todas las funcionalidades.',
            });
          }
        }
      } catch (error) {
      }
    };

    // Verificar inmediatamente
    checkAndHandleExpiration();

    // Verificar cada hora
    const interval = setInterval(checkAndHandleExpiration, 1000 * 60 * 60);

    return () => clearInterval(interval);
  }, [user, showToast]);
}
